// extracted by mini-css-extract-plugin
export default {"linkButton":"kiosk-item-prices_linkButton__qeX+n"};